import { useAppDispatch } from './state'
import {
  getMemberBenefits as getMemberBenefitsAPI,
  getMemberBenefit as getMemberBenefitAPI,
  downloadVoucher as downloadVoucherAPI,
  joinCampaign as joinCampaignAPI
} from '../api/member_benefits'
import {
  setMemberBenefits,
  setMemberBenefit,
  setIsMemberBenefitLoading
} from '../state/slices/member_benefit_slice'
import { useEffect } from 'react'

export const useMemberBenefits = (id?: string) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (id) {
      getMemberBenefit(id)
    }
  }, [id])

  const getMemberBenefits = async () => {
    dispatch(setIsMemberBenefitLoading(true))
    const result = await getMemberBenefitsAPI()

    if (result.data) {
      dispatch(setMemberBenefits(result.data))
    }

    dispatch(setIsMemberBenefitLoading(false))
  }

  const getMemberBenefit = async (id: string) => {
    dispatch(setIsMemberBenefitLoading(true))
    const result = await getMemberBenefitAPI(id)

    if (result.data) {
      dispatch(setMemberBenefit(result.data))
    }

    dispatch(setIsMemberBenefitLoading(false))
  }

  const downloadVoucher = async (id: string) => {
    dispatch(setIsMemberBenefitLoading(true))
    const result = await downloadVoucherAPI(id)

    if (result.data) {
      dispatch(setMemberBenefit(result.data))
    }

    dispatch(setIsMemberBenefitLoading(false))
  }

  const joinCampaign = async (id: string) => {
    dispatch(setIsMemberBenefitLoading(true))
    const result = await joinCampaignAPI(id)

    if (result.data) {
      dispatch(setMemberBenefit(result.data))
    }

    dispatch(setIsMemberBenefitLoading(false))
  }

  return {
    getMemberBenefits,
    getMemberBenefit,
    downloadVoucher,
    joinCampaign
  }
}

export default useMemberBenefits
